<template>
  <div class="damage">
    <div class="columns">
      <div class="is-two-thirds">
        <h4>{{ $lang.translate('track.label.deviationType') }}: {{ damage.type }}</h4>
        <p>
          {{ $lang.translate('track.label.deviationEvent')}}: {{ damage.event }}<br>
          {{ $lang.translate('track.label.deviationCause')}}: {{ damage.reason }}<br>
          {{ $lang.translate('track.label.deviationComment')}}: {{ damage.comment }}<br>
          {{ $lang.translate('track.label.deviationTime')}}: {{ formatDate(damage.dateAndTime) }}<br>
          <template v-if="damage.packageIds.length > 0">IDs: {{ formatPackageIds(damage.packageIds) }}</template>
        </p>
      </div>
      <div class="is-third" v-if="damage.images.length > 0">
        <div class="damage-image-container" v-for="image in damage.images" :key="image.id">
          <a href="#" @click.prevent="openModal(image.url)" class="image-wrapper"><img :src="image.url" :alt="image.id" /></a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { dateFormat } from '@/utils'
export default {
  props: {
    damage: {
      type: Object,
      required: true
    }
  },
  methods: {
    openModal(imageUrl) {
      this.$emit('openModal', imageUrl)
    },
    formatDate(dateTime) {
      return dateFormat(dateTime, {year: 'numeric', month: 'numeric', day: 'numeric'}) + ' - ' + dateFormat(dateTime, { hour: 'numeric', minute: 'numeric'})
    },
    formatPackageIds(ids) {
      return ids.join(', ')
    },
  }
}
</script>

<style scoped>
.damage {
  padding: 1rem 0;
}

.damage:not(:last-child) {  
  border-bottom: 1px solid #D3D3D3;
}

h4 {
  font-size: 20px;
  line-height: 32px;
}

.damage-image-container {
  display: flex;
  justify-content: flex-end;
  align-items: flex-end;
}

.icon-download {
  color: #aaa;
}

.download-link {  
  padding: 21px 25px;
  font-size: 18px;
  font-weight: 700;
}

.image-wrapper {
  width: 160px;
  height: 160px;
}
.image-wrapper img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
}

.image-wrapper img:hover {
  opacity: 0.8;
}

@media(max-width: 1023px) {
  .damage-image-container {
    flex-direction: column-reverse;
    align-items: center;
  }
}

@media(min-width: 1024px) {
  .download-link {
    margin-right: 20px;
  }
}
</style>